import React from 'react';
import { CanvasLayout, useCanvasStore } from '../canvas/index.js';
import { ensureMarketOverviewCanvas } from '../canvas/presets/marketOverview.js';

export const MarketOverviewRoute: React.FC = () => {
  React.useEffect(() => {
    const store = useCanvasStore.getState();
    const canvasId = ensureMarketOverviewCanvas(store);
    store.setActiveCanvas(canvasId);
  }, []);

  return <CanvasLayout paletteInitiallyOpen={false} readOnly />;
};
